import Cookies from '@comeon/tomcat-cookies';
import { insertDataLayer, insertOldPixel, insertTrackEvent, insertOldPixelWithoutSession } from './common.js';

const clearRegistrationCookies = type => {
	const clearRegistration = type === 'registration' || type === 'all';
	const clearPayment = type === 'payment' || type === 'all';
	if (clearPayment) Cookies.remove('payment-method');
	if (clearRegistration) Cookies.remove('registration-method');
};

const pushRegistrationGAEvent = ({
	type,
	step,
	action,
	paymentType,
	playerId,
	franchiseName,
	clonableProps = [],
	clearCookies = false,
	regVerification,
	regScreen
}) => {
	const registrationType = type || Cookies.get('registration-method') || 'full-account';
	const paymentMethod = paymentType || Cookies.get('payment-method') || 'none';
	const params = {
		pixel_reg_type: registrationType,
		pixel_reg_step: step || 'none',
		pixel_reg_action: action || 'none',
		pixel_payment_method: paymentMethod,
		pixel_playerId: playerId,
		pixel_franchiseName: franchiseName,
		pixel_reg_verification: regVerification || 'none',
		pixel_screen: regScreen
	};
	// filter out ones with falsy value
	const validParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => _ && !!v));
	insertDataLayer('RegPixelTracking', validParams, clonableProps);
	// clear cookie on registration
	if (clearCookies) {
		clearRegistrationCookies('all');
	}
};

// if its login, get login type from the registration cookies
//  if payment method exists send that as well
const getLoginType = () => {
	const registrationMethod = Cookies.get('registration-method');
	const paymentMethod = Cookies.get('payment-method');
	if (registrationMethod) {
		return `${registrationMethod} ${!!paymentMethod && paymentMethod !== 'none' ? paymentMethod : ''}`.trim();
	}
	return null;
};

const registrationSuccess = ({ method, oldEvent = false, newEvent = false, encryptedPID = null }) => {
	const label = method || getLoginType();

	// skip firing event if method is missing
	if (!label) {
		return;
	}
	// old events to be removed
	if (newEvent) {
		insertTrackEvent({
			category: 'Registration',
			action: 'Successful',
			label
		});
	} else if (oldEvent) {
		insertTrackEvent({
			category: 'register',
			action: 'Successful',
			label
		});
	} else {
		// by default fire both and request the old pixel (for user/pass login)
		insertTrackEvent({
			category: 'register',
			action: 'Successful',
			label
		});
		insertTrackEvent({
			category: 'Registration',
			action: 'Successful',
			label
		});
	}
	// if session is not active and encrypted pid is available,
	if (encryptedPID) {
		insertOldPixelWithoutSession({ encryptedPID });
	} else {
		insertOldPixel('fullReg');
	}
};

const registrationFailure = ({ method = null, error = '', oldEvent = false, newEvent = false }) => {
	const type = method || getLoginType() || '';
	const label = `${type} - ${error}`;
	// by default fire both
	if (newEvent) {
		insertTrackEvent({
			category: 'Registration',
			action: 'Failed',
			label
		});
	} else if (oldEvent) {
		insertTrackEvent({
			category: 'register',
			action: 'Failed',
			label: type
		});
	} else {
		insertTrackEvent({
			category: 'register',
			action: 'Failed',
			label: type
		});
		insertTrackEvent({
			category: 'Registration',
			action: 'Failed',
			label
		});
	}
};

const registrationStart = ({ method }) => {
	const label = method || getLoginType();
	insertTrackEvent({
		category: 'Registration',
		action: 'Start',
		label
	});
};

export {
	pushRegistrationGAEvent,
	clearRegistrationCookies,
	getLoginType,
	registrationSuccess,
	registrationFailure,
	registrationStart
};
